var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.493,
    height: 81.5,
    viewBox: "0 0 81.493 81.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data_tech_sq-01-square",
    transform: "translate(-3.577 -4.04)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 47.999,
    height: 72.001,
    transform: "translate(20.324 6.944)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x1: 7.999,
    transform: "translate(40.321 14.943)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    y1: 15.997,
    x2: 15.997,
    transform: "translate(68.323 4.79)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    y1: 17.017,
    x2: 17.017,
    transform: "translate(51.306 20.787)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "6 3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    y1: 16.959,
    x2: 16.959,
    transform: "translate(20.324 51.834)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "6 3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    y1: 15.997,
    x2: 16.004,
    transform: "translate(4.32 68.793)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x2: 15.997,
    y2: 15.997,
    transform: "translate(68.323 68.793)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 16.959,
    y2: 16.959,
    transform: "translate(51.364 51.834)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "6 3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x2: 16.959,
    y2: 16.959,
    transform: "translate(20.324 20.787)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "6 3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 16.004,
    y2: 15.997,
    transform: "translate(4.32 4.79)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80246",
    "data-name": "Path 80246",
    d: "M58.911,45.526,64.3,54.86l-5.385,9.334H48.141L42.727,54.86l5.392-9.334h10.77M61.761,40.5H45.233L36.94,54.86l8.293,14.36H61.812L70.1,54.86,61.812,40.5Z",
    transform: "translate(-9.199 -10.07)",
    fill: "#12784a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80247",
    "data-name": "Path 80247",
    d: "M113.766,109.21v5.026H108.74",
    transform: "translate(-29.446 -29.446)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80248",
    "data-name": "Path 80248",
    d: "M9.349,114.236H4.33V109.21",
    transform: "translate(-0.003 -29.446)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80249",
    "data-name": "Path 80249",
    d: "M4.33,9.816V4.79H9.356",
    transform: "translate(-0.003)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80250",
    "data-name": "Path 80250",
    d: "M108.74,4.79h5.026V9.816",
    transform: "translate(-29.446)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco2);
export default __webpack_public_path__ + "static/media/ico2.93cfc1a01a360820411e065d48799d94.svg";
export { ForwardRef as ReactComponent };